var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('el-tooltip',{staticClass:"pulse pull-right",attrs:{"effect":"light","placement":"right","popper-class":"tooltip-help"},scopedSlots:_vm._u([{key:"content",fn:function(){return [_c('div',{domProps:{"innerHTML":_vm._s(_vm.content)}})]},proxy:true}])},[_c('i',{staticClass:"el-icon-question"})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }